// extracted by mini-css-extract-plugin
module.exports = {"padded":"common_padded__YCgsC","flexPadded":"common_flexPadded__2L2AO flex_flex__woFO6 common_padded__YCgsC","page":"common_page__3ZnCt","clear":"common_clear__3VcMV"};